<template>
  <div v-if="resultEvaluation">
    <!--Stats cards-->
    <div class="row">
      <div class="col-lg-12">
        <h5 class="title_h5">Gestor Imediato</h5>
        <div class="card">
          <div class="card-content desc_member">
            <div class="row">
              <div class="col-md-2 col-xs-4">
                <div class="avatar img_member">
                  <img :src="currentUser.avatar_url" alt="Circle Image"
                    class="img-circle img-no-padding img-responsive">
                </div>
              </div>
              <div class="col-md-10 col-xs-8">
                <div class="pull-left name_member">
                  <span>
                    {{ currentUser.name }}
                  </span><br /><small>{{ currentUser.position.functional_classification.name }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <h5 class="title_h5">Colaborador</h5>
        <div class="card">
          <div class="card-content desc_member">
            <div class="row">
              <div class="col-md-2 col-xs-4">
                <div class="avatar img_member"><img :src="resultEvaluation.collaborator.avatar_url" alt="Circle Image"
                    class="img-circle img-no-padding img-responsive"></div>
              </div>
              <div class="col-md-10 col-xs-8">
                <div class="pull-left name_member">
                  <span>
                    {{ resultEvaluation.collaborator.name }}
                  </span><br /><small>{{ resultEvaluation.collaborator.position.name }}</small> <br>
                  <a :href="whatsappGenerateLink(resultEvaluation.collaborator.phone)" class="whatsapp-collaborator"
                    target="_blank" v-if="resultEvaluation.collaborator.phone">
                    <i class="fa fa-whatsapp"></i> <span>Vídeo chamada</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="card card-competencias">
          <div class="card-content">
            <div class="row">
              <div class="col-md-12">
                <h4 class="card-title">Plano de Desenvolvimento Individual (PDI)</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center">
                O Plano de Desenvolvimento Individual (PDI) é um método para estabelecer, acompanhar e desenvolver as
                competências do seu colaborador. É um fator decisivo na evolução individual, servindo de guia prático
                para desenvolver competências e habilidades.
                <br>
                <br>
                Com base no resultado da avaliação de desempenho você, juntamente, com o colaborador deverá especificar
                a ação a ser tomada considerando prática, treinamento e feedback contínuo.
                <br>
                <br>
                É importante estabelecer o prazo de início e conclusão para cada ação.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div></div>
        <div class="card card-competencias">
          <div class="card-content">
            <div class="row">
              <div class="col-md-12">
                <h4 class="card-title">RESULTADO DA AVALIAÇÃO</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-sm-12">
                <circle-chart-card :percentage="resultEvaluation.final_result" title="RESULTADO FINAL"
                  :description="resultEvaluation.evaluation_type_name"
                  :color="percentTotalColor(resultEvaluation.final_result)">
                </circle-chart-card>
              </div>
              <div class="col-lg-6 col-sm-6">
                <circle-chart-card :percentage="resultEvaluation.total_skill_percent" title="COMPETÊNCIAS"
                  :color="percentTotalColor(resultEvaluation.total_skill_percent)">
                </circle-chart-card>
              </div>
              <div class="col-lg-6 col-sm-6">
                <circle-chart-card :percentage="resultEvaluation.delivery_percent" title="ENTREGA"
                  :color="percentTotalColor(resultEvaluation.delivery_percent)">
                </circle-chart-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <info-pdi-9box :resultEvaluation="resultEvaluation"></info-pdi-9box>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <div class="card-content">
            <div class="row">
              <div class="col-lg-12">
                Escolha as competências que você deseja incluir no Plano de Ação do colaborador.*<br /><br />
              </div>

              <div class="col-lg-12">
                <el-select multiple class="select-default" size="large" placeholder="Selecione..."
                  v-model="developmentPlan.skill_ids">
                  <el-option v-for="skill in resultEvaluation.collaborator.skills" :value="skill.id" :label="skill.name"
                    :key="skill.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <br>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="skillView.id">
      {{ skillView }}
      <div class="col-lg-12 col-sm-12">
        <stats-card>
          <div class="icon-big text-center" :class="`icon-${percentColor(skillView.percent)}`" slot="header">
            <i class="ti-package"></i>
          </div>
          <div class="numbers" slot="content">
            <p class="category">COMPETÊNCIA</p>
          </div>
          <div class="stats" slot="footer">
            <div class="row">
              <div class="col-xs-10 comp">
                {{skillView.name}}
              </div>
              <div class="col-xs-2 grade_comp">
                {{skillView.percent}}%
              </div>
            </div>
            <p-progress :value="skillView.percent" :type="percentColor(skillView.percent)"></p-progress>
          </div>
        </stats-card>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Plano de Ação</h4>
            <p class="category">Por favor, preencha o formulário de Plano de Ação Individual detalhando o objetivo
              principal de desenvolvimento, as áreas de melhoria identificadas, as metas específicas, as estratégias
              para alcançar essas metas, os indicadores de sucesso, a frequência de monitoramento e o tempo de execução
              previsto,. Este plano será essencial para o crescimento professional do colaborador e alinhamento com os
              objetivos da empresa.
            </p>
          </div>
          <div class="card-content">
            <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Plano de Desenvolvimento*</label>
                  <div>
                    <el-select class="select-default" size="large" placeholder="Selecione..." v-model="developmentPlan.development_plan_id" @change="developmentPlanShow()">
                      <el-option v-for="developmentPlan in developmentPlans" class="select-default"
                                      :value="developmentPlan.id"
                                      :label="developmentPlan.name"
                                      v-show="checkAccessUser(developmentPlan.id)"
                                      :key="developmentPlan.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>                
              </div>
            </div> -->
            <div class="row" v-if="!!developmentPlanSelected.description">
              <div class="col-md-12" style="margin-bottom:13px;">
                <blockquote style="font-style: normal; font-size: 14px;">
                  {{ developmentPlanSelected.description }}
                </blockquote>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Descrição do Plano de Ação* </label>
                  <textarea class="form-control" placeholder="Descreva as atividades a serem executadas." rows="3" v-model="developmentPlan.description" maxlength="2000"></textarea>
                </div>
              </div>
            </div> -->
            <div class="row">
              <div class="col-md-12" style="margin-bottom:13px;"><br />
                Estime o tempo necessário para participar das atividades de desenvolvimento, incluindo treinamentos,
                workshops e outras iniciativas. Defina claramente as datas de início e término. Tempo mínimo: 20 dias.
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Data de Início*</label>
                  <div>
                    <el-date-picker v-model="developmentPlan.start_date" format="dd/MM/yyyy" value-format="yyyy-MM-dd"
                      type="date" placeholder="Selecione a data" :picker-options="pickerOptionsStart" @change="clearAllDates">
                    </el-date-picker>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Data de Término*</label>
                  <div>
                    <el-date-picker v-model="developmentPlan.end_date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" :disabled="!developmentPlan.start_date"
                      type="date" placeholder="Selecione a data" :picker-options="pickerOptionsEnd" @change="clearAllDates">
                    </el-date-picker>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Objetivo do Plano de Ação*</label><i rel="tooltip"
                    title="Descreva brevemente o objetivo principal deste plano de ação. O objetivo deve ser claro e específico, focando em uma área de desenvolvimento que será trabalhada ao longo do período definido."
                    class="fa fa-info-circle" aria-hidden="true"></i>
                  <textarea class="form-control"
                    placeholder="Ex.: Aprimorar habilidades de análise de dados para otimizar os processos da área; Desenvolver competências de liderança para coordenar uma equipe no próximo ano."
                    rows="3" v-model="developmentPlan.action_plan_objective" maxlength="2000"></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Áreas de Melhoria Identificadas*</label><i rel="tooltip"
                    title="Enumere as habilidades técnicas e competências comportamentais específicas que precisam ser aprimoradas para alcançar as metas estabelecidas no plano de ação. Identifique quais competências são essenciais para o sucesso no desenvolvimento do colaborador."
                    class="fa fa-info-circle" aria-hidden="true"></i>
                  <textarea class="form-control"
                    placeholder="Ex.: Técnicas: Uso avançado do Excel, Gestão de Processos, Análise de Dados; Comportamentais: Comunicação eficaz, Gestão de Tempo, Resolução de Problemas."
                    rows="3" v-model="developmentPlan.identified_improvement_areas" maxlength="2000"></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">
                    Metas do Plano de Ação*
                    <i rel="tooltip"
                      title="Defina metas alcançáveis e objetivos de desenvolvimento que sejam específicos, mensuráveis, atingíveis, relevantes e com prazo definido."
                      class="fa fa-info-circle" aria-hidden="true"></i>
                  </label>

                  <!-- Lista de metas -->
                  <div v-for="(goalItem, index) in developmentPlan.action_plan_goals" :key="index" class="well" style="padding: 15px; margin-bottom: 10px;">
                    <div class="form-group">
                      <label>Meta {{ index + 1 }}*</label>
                      <input type="text"
                            class="form-control"
                            v-model="goalItem.goal"
                            :placeholder="'Digite a meta ' + (index + 1)"
                            maxlength="200">
                    </div>
                    
                    <div class="form-group">
                      <label class="control-label">Prazo*</label>
                      <div>
                        <el-date-picker 
                          v-model="goalItem.due_date" 
                          format="dd/MM/yyyy" 
                          value-format="yyyy-MM-dd"
                          type="date" 
                          placeholder="Selecione a data" 
                          :picker-options="pickerOptionsGoals"
                          :disabled="!developmentPlan.start_date || !developmentPlan.end_date">
                        </el-date-picker>
                      </div>
                    </div>

                    <div class="form-group">
                      <label>Estratégias para alcançar essa meta*</label>
                      <textarea class="form-control"
                                v-model="goalItem.strategy"
                                placeholder="Ex.: Participação em cursos, feedbacks periódicos, envolvimento em projetos..."
                                rows="3"
                                maxlength="2000"></textarea>
                    </div>

                    <button class="btn btn-danger btn-sm"
                            type="button"
                            @click="removeGoal(index)"
                            :disabled="developmentPlan.action_plan_goals.length === 1">
                      <i class="fa fa-trash"></i> Remover
                    </button>
                  </div>

                  <!-- Botão de adicionar -->
                  <button class="btn btn-info btn-sm" type="button" @click="addGoal">
                    <i class="fa fa-plus"></i> Adicionar Meta
                  </button>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Estratégias para Alcançar as Metas*</label><i rel="tooltip"
                    title="Descreva as atividades específicas que serão realizadas para aprimorar as habilidades técnicas do colaborador e as iniciativas destinadas a melhorar as competências comportamentais identificadas."
                    class="fa fa-info-circle" aria-hidden="true"></i>
                  <textarea class="form-control"
                    placeholder="Ex.: Participação em cursos online e presenciais; Envolvimento em projetos específicos; Feedback estruturado e regular sobre o desempenho nas atividades executadas."
                    rows="3" v-model="developmentPlan.strategies_to_reach_goals" maxlength="2000"></textarea>
                </div>
              </div>
            </div> -->
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Indicadores de Sucesso*</label><i rel="tooltip"
                    title="Defina como o progresso e o sucesso serão medidos ao longo do plano de ação"
                    class="fa fa-info-circle" aria-hidden="true"></i>
                  <div v-for="(indicator, index) in successIndicators" :key="index">
                    <input type="checkbox" :id="'success-indicator-checkbox-' + index" :value="indicator.id"
                      v-model="developmentPlan.success_indicators" />
                    <label :for="'success-indicator-checkbox-' + index" class="non-bold-label">{{ indicator.description
                      }}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-gorup">
                  <label class="control-label">Frequência de Monitoramento* </label><i rel="tooltip"
                    title="Especifique com que frequência o progresso será revisado e ajustado"
                    class="fa fa-info-circle" aria-hidden="true"></i>
                  <div v-for="(frequency, index) in monitoringFrequency" :key="index">
                    <input type="checkbox" :id="'monitoring-frequency-checkbox-' + index" :value="frequency.id"
                      v-model="developmentPlan.monitoring_frequencies" />
                    <label :for="'monitoring-frequency-checkbox-' + index" class="non-bold-label">{{
                      frequency.description }}</label>
                  </div>
                </div>
              </div>
            </div> -->
            
            <div class="row">
              <div class="col-md-12" style="margin-bottom:13px;"><br />
                Defina reuniões periódicas de acompanhamento para monitorar e avaliar o desenvolvimento do colaborador. Cada reunião deve ter um intervalo de no mínimo 15 dias da data de início ou da última reunião. Você poderá alterar/definir novas datas depois.
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">
                    Reuniões de Acompanhamento* 
                    <i rel="tooltip"
                      title="Adicione uma ou mais datas para as reuniões de acompanhamento."
                      class="fa fa-info-circle"
                      aria-hidden="true"></i>
                  </label>

                  <!-- Lista de datas -->
                  <div v-for="(meeting, index) in developmentPlan.monitoring_meetings" :key="index" class="input-group" style="margin-bottom: 10px;">
                    <el-date-picker
                      v-model="developmentPlan.monitoring_meetings[index]"
                      format="dd/MM/yyyy"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="Selecione a data"
                      :disabled="!developmentPlan.start_date || !developmentPlan.end_date"
                      :picker-options="getMeetingDatePickerOptions(index)">
                    </el-date-picker>
                    <span class="input-group-btn">
                      <button class="btn btn-danger btn-sm"
                              type="button"
                              @click="removeMeetingDate(index)"
                              :disabled="developmentPlan.monitoring_meetings.length === 1">
                        <i class="fa fa-trash"></i>
                      </button>
                    </span>
                  </div>

                  <!-- Botão de adicionar nova data manual -->
                  <button class="btn btn-info btn-sm" type="button" @click="addMeetingDate" :disabled="!canAddNewMeetingDate" :title="!canAddNewMeetingDate ? 'Não é possível adicionar mais reuniões dentro do intervalo atual' : ''">
                    <i class="fa fa-plus"></i> Adicionar Data
                  </button>
                  <span v-if="noMeetingDateAvailable" style="font-size: 12px; color: gray; margin-left: 10px;">Não é possível adicionar mais reuniões dentro do intervalo atual.</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Atenção</h4>
            Após inserir o Plano de Ação a avaliação não pode ser editada.
          </div>
          <div class="card-content">
            <div class="row">
              <div class="col-lg-12 col-sm-12 text-center">
                <button type="button" class="btn btn-success btn-fill btn-rotate bt-end"
                  @click="validDevelopmentPlan()"><span class="btn-label"><i class="ti-pencil-alt"></i></span>
                  Inserir Plano de Ação
                </button>
                <button type="button" class="btn btn-warning btn-fill btn-rotate bt-end" @click="evaluationEdit()"><span
                    class="btn-label"><i class="ti-angle-left"></i></span>
                  Editar Avaliação
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option, Collapse, CollapseItem} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import VueTabs from 'vue-nav-tabs'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import PProgress from 'src/components/UIComponents/Progress.vue'
  import { checkAccessPowerUniversity } from 'src/helpers/general'
  import InfoPDI9Box from './InfoPDI9Box.vue'
  import swal from 'sweetalert2'
  import $ from 'jquery'

  Vue.use(VueTabs)
  Vue.use(Collapse)
  Vue.use(CollapseItem)
  export default {
    mounted () {
      this.evaluationId = this.$route.params.evaluationId
      this.collaboratorId = this.$route.params.collaboratorId
      this.developmentPlan.evaluation_id = this.evaluationId
      this.getResultEvaluation()
      this.getDevelopmentPlans()
      this.getSuccessIndicators()
      this.getMonitoringFrequency()
    },
    components: {
      StatsCard,
      ChartCard,
      CircleChartCard,
      // WorldMap,
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      [InfoPDI9Box.name]: InfoPDI9Box,
      PSwitch,
      PProgress
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    created () {
      $('html, body').animate({ scrollTop: 0 }, 600)
    },
    data () {
      const vm = this

      return {
        evaluationId: null,
        resultEvaluation: null,
        developmentPlans: [],
        successIndicators: [],
        monitoringFrequency: [],
        developmentPlanSelected: {},
        skillId: [],
        skillView: {},
        collaboratorId: null,
        loading: false,
        developmentPlan: {
          evaluation_id: '',
          development_plan_id: 6,
          description: '',
          action_plan_objective: '',
          identified_improvement_areas: '',
          // action_plan_goals: '',
          action_plan_goals: [{
            goal: '',
            strategy: '',
            due_date: ''
          }],
          strategies_to_reach_goals: '',
          start_date: '',
          end_date: '',
          success_indicators: [],
          monitoring_frequencies: [],
          monitoring_meetings: [''],
          skill_ids: []
        },
        noMeetingDateAvailable: false,
        pickerOptionsStart: {
          // shortcuts: [{
          //   text: 'Hoje',
          //   onClick (picker) {
          //     picker.$emit('pick', new Date())
          //   }
          // }],
          disabledDate (date) {
            if ((date < new Date())) { // Desabilitar dias anteriores e data atual.
              return true
            } else {
              return false
            }
          }
        },
        pickerOptionsEnd: {
          disabledDate: (date) => {
            const today = new Date()
            const start = this.developmentPlan.start_date ? new Date(this.developmentPlan.start_date) : null

            const d = new Date(date)

            if (d < today) return true // Não permite antes de hoje
            if (start && d <= start) return true // Não permite antes ou igual à data de início

            // Regra: mínimo 20 dias após a data de início
            if (start) {
              const minEndDate = new Date(start)
              minEndDate.setDate(minEndDate.getDate() + 20)
              if (d < minEndDate) return true
            }
            return false
          }
        },
        pickerOptionsGoals: {
          disabledDate: (date) => {
            const start = this.developmentPlan.start_date ? new Date(this.developmentPlan.start_date) : null
            const end = this.developmentPlan.end_date ? new Date(this.developmentPlan.end_date) : null

            if (!start || !end) return true // Desabilita tudo se não houver datas definidas

            const current = new Date(date)
            return current < start || current > end
          }
        }
      }
    },
    methods: {
      openOverview (evaluationId) {
        this.$router.push(`/avaliacao/equipe/perfil/${this.collaboratorId}/resultado-completo/${evaluationId}`)
      },
      openSetPlan (evaluationId) {
        this.$router.push(`/avaliacao/formulario-resultado/${evaluationId}/${this.collaboratorId}`)
      },
      addGoal () {
        this.developmentPlan.action_plan_goals.push({goal: '', strategy: '', due_date: ''})
      },
      removeGoal (index) {
        if (this.developmentPlan.action_plan_goals.length > 1) {
          this.developmentPlan.action_plan_goals.splice(index, 1)
        }
      },
      percentColor (percent) {
        let classColor = 'success'

        if (percent >= 0 && percent < 40) {
          classColor = 'danger'
        } else if (percent >= 40 && percent < 80) {
          classColor = 'warning'
        }
        return classColor
      },
      percentTotalColor (percent) {
        let color = 'green'

        if (percent >= 0 && percent < 40) {
          color = 'red'
        }

        if (percent >= 40 && percent < 80) {
          color = 'orange'
        }

        return color
      },
      getResultEvaluation () {
        let url = `/collaborator/manager/collaborator-evaluation-plan/${this.evaluationId}`
        axios.get(url).then((res) => {
          this.resultEvaluation = res.data
        }).catch(error => {
          let message = 'Não foi possível completar a requisição, tente novamente mais tarde.'

          if (error.response.status !== 500) {
            message = error.response.data.error
          }

          swal({
            title: 'Avaliação!',
            text: message,
            type: 'error',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'Voltar',
            buttonsStyling: false,
            allowOutsideClick: false,
            preConfirm: () => {
              return (new Promise((resolve, reject) => {
                resolve('OK')
              }))
            }
          }).then(() => {
            this.$router.push(`/avaliacao/equipe`)
          }).catch(swal.noop)
        })
      },
      getDevelopmentPlans () {
        let url = `/collaborator/manager/development-plan-evaluation`
        axios.get(url).then((res) => {
          this.developmentPlans = res.data
        })
      },
      getSuccessIndicators () {
        let url = '/collaborator/manager/success-indicator'
        axios.get(url).then((res) => {
          this.successIndicators = res.data
        })
      },
      getMonitoringFrequency () {
        let url = '/collaborator/manager/monitoring-frequency'
        axios.get(url).then((res) => {
          this.monitoringFrequency = res.data
        })
      },
      checkAccessUser (developmentPlanId) {
        if (developmentPlanId === 5) {
          return checkAccessPowerUniversity(this.currentUser)
        }

        return true
      },
      validDevelopmentPlan () {
        const goals = this.developmentPlan.action_plan_goals || []
        const hasInvalidGoal = goals.some(goal => {
          return (
            !goal.goal ||
            !goal.strategy ||
            !goal.due_date
          )
        })
        if (!!this.developmentPlan.evaluation_id &&
          !!this.developmentPlan.development_plan_id &&
          !!this.developmentPlan.action_plan_objective &&
          !!this.developmentPlan.identified_improvement_areas &&
          !!this.developmentPlan.action_plan_goals &&
          !!this.developmentPlan.start_date &&
          !!this.developmentPlan.end_date &&
          this.developmentPlan.skill_ids.length !== 0 &&
          this.developmentPlan.success_indicators.length !== 0 &&
          this.developmentPlan.monitoring_meetings.length > 0 &&
          this.developmentPlan.monitoring_meetings.every(date => !!date) &&
          // this.developmentPlan.monitoring_frequencies.length !== 0 &&
          !hasInvalidGoal
        ) {
          this.validAccess()
        } else {
          swal({
            title: 'Plano de Ação!',
            text: 'Preencha todo os campos (*) obrigatórios.',
            type: 'error',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'OK',
            buttonsStyling: false,
            allowOutsideClick: false
          }).catch(swal.noop)
        }
      },
      saveDevelopmentPlan (dataAccess) {
        const dataDevelopmentPlan = {
          ...(this.developmentPlan),
          token: dataAccess.access_token
        }

        swal({
          title: 'Você tem certeza!',
          html: 'Plano de Ação será finalizada.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Enviar Plano de Ação',
          buttonsStyling: false,
          preConfirm: async () => {
            let url = '/collaborator/manager/collaborator-evaluation-plan'
            await axios.post(url, dataDevelopmentPlan)
            .catch(error => {
              let message = 'Não foi possível completa requisição, tente novamente mais tarde.'
              if (error.response.status !== 500) {
                message = error.response.data.error
              }
              swal.showValidationError(message)
              return (new Promise((resolve, reject) => {
                reject(new Error(message))
              }))
            })
          }
        })
        .then((res) => {
          swal({
            title: 'Plano de Ação!',
            text: 'Plano de Ação foi enviado com sucesso.',
            type: 'success',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'OK',
            buttonsStyling: false,
            allowOutsideClick: false,
            preConfirm: () => {
              return (new Promise((resolve, reject) => {
                resolve('OK')
              }))
            }
          }).then(() => {
            this.$router.push(`/avaliacao/equipe`)
          })
        }).catch(swal.noop)
      },
      validAccess () {
        const evaluationId = this.evaluationId
        swal({
          title: 'Código Verificador',
          input: 'number',
          inputPlaceholder: 'Ex: 785438',
          html: '<small>Peça ao seu colaborador o código verificador que aparece no sistema de Avaliação de Desempenho em seu telefone celular.</small>',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Verificar',
          buttonsStyling: false,
          preConfirm: code => {
            if (!code) {
              swal.showValidationError('Informe um código verificador.')
              return new Promise((resolve, reject) => {
                reject(new Error('Informe o código verificador.'))
              })
            }

            return this.verifyCode(evaluationId, code).catch(error => {
              let message =
                'Não foi possível completar a requisição, tente novamente mais tarde.'
              if (error.response.status !== 500) {
                message = error.response.data.error
              }

              swal.showValidationError(message)

              return new Promise((resolve, reject) => {
                reject(new Error(message))
              })
            })
          }
        }).then(res => {
          this.saveDevelopmentPlan(res.data)
        })
      },
      verifyCode (evaluationId, code) {
        return axios.post('/collaborator/manager/verify-code-evaluation', {
          evaluation_id: evaluationId,
          code
        })
      },
      developmentPlanShow () {
        const developmentPlan = this.developmentPlans.find(value => value.id === this.developmentPlan.development_plan_id)

        if (developmentPlan) {
          this.developmentPlanSelected = developmentPlan
        } else {
          this.developmentPlanSelected = {}
        }
      },
      evaluationEdit () {
        const evaluationId = this.evaluationId
        this.$router.push(`/avaliacao/formulario-editar/${evaluationId}/${this.collaboratorId}`)
      },
      whatsappGenerateLink (phone) {
        if (phone) {
          phone = phone.replace(/[^\d]+/g, '')
          let link = `https://api.whatsapp.com/send?phone=55${phone}&text=Olá! Iniciaremos neste momento o seu feedback. Por favor, procure um local tranquilo para começarmos.`
          return link
        }
      },
      addMeetingDate () {
        this.developmentPlan.monitoring_meetings.push('')
        this.$nextTick(() => {
          this.updateMeetingAvailability()
        })
      },
      removeMeetingDate (index) {
        if (this.developmentPlan.monitoring_meetings.length > 1) {
          this.developmentPlan.monitoring_meetings.splice(index, 1)
          this.$nextTick(() => {
            this.updateMeetingAvailability()
          })
        }
      },
      getMeetingDatePickerOptions (index) {
        return {
          disabledDate: (date) => {
            const start = this.developmentPlan.start_date ? new Date(this.developmentPlan.start_date) : null
            const end = this.developmentPlan.end_date ? new Date(this.developmentPlan.end_date) : null

            if (!start || !end) return true // Desabilita tudo se não tiver início e fim

            // Define a data mínima
            let minDate = new Date(start)

            if (index > 0) {
              const prevMeeting = this.developmentPlan.monitoring_meetings[index - 1]
              if (prevMeeting) {
                minDate = new Date(prevMeeting)
              }
            }

            minDate.setDate(minDate.getDate() + 15) // Pelo menos 15 dias após início ou última reunião

            const currentDate = new Date(date)

            return currentDate < minDate || currentDate > end
          }
        }
      },
      updateMeetingAvailability () {
        const start = this.developmentPlan.start_date ? new Date(this.developmentPlan.start_date) : null
        const end = this.developmentPlan.end_date ? new Date(this.developmentPlan.end_date) : null

        if (!start || !end) {
          this.noMeetingDateAvailable = true
          return
        }

        // Base da última reunião
        const meetings = this.developmentPlan.monitoring_meetings.filter(m => !!m)
        let baseDate = meetings.length > 0 ? new Date(meetings[meetings.length - 1]) : new Date(start)
        baseDate.setDate(baseDate.getDate() + 15)

        // Verifica se ainda existe data válida
        if (baseDate >= end) {
          // Desabilita botão
          this.noMeetingDateAvailable = true

          // Remove inputs vazios
          this.developmentPlan.monitoring_meetings = this.developmentPlan.monitoring_meetings.filter(m => !!m)

          // Garante pelo menos um campo visível
          if (this.developmentPlan.monitoring_meetings.length === 0) {
            this.developmentPlan.monitoring_meetings.push('')
          }
        } else {
          this.noMeetingDateAvailable = false
        }
      },
      clearAllDates (value) {
        if (!value) {
          this.developmentPlan.end_date = ''
          this.developmentPlan.action_plan_goals.forEach(goal => {
            goal.due_date = ''
          })
          this.developmentPlan.monitoring_meetings = this.developmentPlan.monitoring_meetings.map(() => '')

          const nonEmpty = this.developmentPlan.monitoring_meetings.filter(date => !!date)

          this.developmentPlan.monitoring_meetings = nonEmpty.length > 0 ? nonEmpty : ['']

          this.updateMeetingAvailability()
        }
      }
    },
    computed: {
      currentUser () {
        return this.$store.getters.currentUser
      },
      monitoringMeetingSignature () {
        // Junta todas as datas em uma única string
        return this.developmentPlan.monitoring_meetings.join('|')
      },
      canAddNewMeetingDate () {
        const meetings = this.developmentPlan.monitoring_meetings
        const lastMeeting = meetings[meetings.length - 1]
        return !this.noMeetingDateAvailable && !!lastMeeting
      }
    },
    watch: {
      // skillId (val) {
      //   this.skillView = this.resultEvaluation.collaborator.skills.find(skill => skill.id === val)
      //   this.developmentPlan.skill_id = this.skillView.id
      // },
      'developmentPlan.end_date' (newDate) {
        if (!newDate) return

        const endDate = new Date(newDate)

        this.developmentPlan.action_plan_goals = this.developmentPlan.action_plan_goals.map(goal => {
          const dueDate = goal.due_date ? new Date(goal.due_date) : null

          if (dueDate && dueDate > endDate) {
            return {...goal, due_date: ''}
          }
          return goal
        })

        this.developmentPlan.monitoring_meetings = this.developmentPlan.monitoring_meetings.map(meeting => {
          const meetingDate = meeting ? new Date(meeting) : null

          if (meetingDate && meetingDate > endDate) {
            return ''
          }
          return meeting
        })

        this.$nextTick(() => {
          this.updateMeetingAvailability()
        })
      },
      'developmentPlan.start_date' (newDate) {
        if (!newDate) return

        const startDate = new Date(newDate)

        this.developmentPlan.action_plan_goals = this.developmentPlan.action_plan_goals.map(goal => {
          const dueDate = goal.due_date ? new Date(goal.due_date) : null

          if (dueDate && dueDate < startDate) {
            return {...goal, due_date: ''}
          }
          return goal
        })

        this.developmentPlan.monitoring_meetings = this.developmentPlan.monitoring_meetings.map(meeting => {
          const meetingDate = meeting ? new Date(meeting) : null

          if (meetingDate && meetingDate < startDate) {
            return ''
          }
          return meeting
        })

        this.$nextTick(() => {
          this.updateMeetingAvailability()
        })
      },
      monitoringMeetingSignature () {
        this.updateMeetingAvailability()
      }
    }
  }

</script>
<style scoped>
.grade_comp{
  text-align:right;
}
.resultado-final-ac{
  margin-top: -16px !important;
}
.resultado-final-ac .el-collapse-item .el-collapse-item__header{
    font-size: 0.85em !important;
}
.resultado-final-ac .el-collapse-item__content{
  padding-bottom:0 !important;
}
h5.card-title{margin-bottom:0 !important;}
.chart-circle {
    margin-top: 3px !important;
    margin-bottom: 17px !important;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}
.select-default {
  color: #FFF !important;
}

.whatsapp-collaborator {
  height: 50px;
  background-color:#25d366;
  color:#FFF !important;
  border-radius: 5px;
  text-align: center !important;
  font-size: 30px;
  box-shadow: 1px 1px 2px #888;
  padding: 0px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.whatsapp-collaborator span {
  font-size: 16px;
  margin-left: 10px;
}

.whatsapp-collaborator:hover {
  opacity: 0.89;
}

.non-bold-label {
  font-weight: normal;
}

.goal-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 8px;
}

.goal-row input {
  flex: 1;
}

.goal-row button {
  margin-left: 8px;
  flex-shrink: 0;
}

@media screen and (max-width: 480px) {    

  .whatsapp-collaborator {    
    height: 45px;
  }

  .whatsapp-collaborator span {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Manager/Evaluation/FormResult.vue